module.exports = __webpack_public_path__ + "static/media/arrowLeft.3eafbb0d.svg";